export var AssemblerName = /* @__PURE__ */ ((AssemblerName2) => {
  AssemblerName2["GL_MESH_BASIC"] = "GL_MESH_BASIC";
  AssemblerName2["GL_MESH_LAMBERT"] = "GL_MESH_LAMBERT";
  AssemblerName2["GL_MESH_STANDARD"] = "GL_MESH_STANDARD";
  AssemblerName2["GL_MESH_PHONG"] = "GL_MESH_PHONG";
  AssemblerName2["GL_MESH_PHYSICAL"] = "GL_MESH_PHYSICAL";
  AssemblerName2["GL_MESH_DEPTH"] = "GL_MESH_DEPTH";
  AssemblerName2["GL_MESH_DISTANCE"] = "GL_MESH_DISTANCE";
  AssemblerName2["GL_PARTICLES"] = "GL_PARTICLES";
  AssemblerName2["GL_POINTS"] = "GL_POINTS";
  AssemblerName2["GL_LINE"] = "GL_LINE";
  AssemblerName2["GL_TEXTURE"] = "GL_TEXTURE";
  AssemblerName2["GL_VOLUME"] = "GL_VOLUME";
  return AssemblerName2;
})(AssemblerName || {});
export class BaseAssemblersRegister {
  constructor() {
    this._controllerAssemblerByName = /* @__PURE__ */ new Map();
  }
  register(name, controller, assembler) {
    this._controllerAssemblerByName.set(name, {
      controller,
      assembler
    });
  }
  unregister(name) {
    this._controllerAssemblerByName.delete(name);
  }
  traverse(callback) {
    this._controllerAssemblerByName.forEach(callback);
  }
}
